import React from 'react';
import { UTButton } from '@widergy/energy-ui';
import { func, bool, any } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { required } from '@widergy/web-utils/lib/validate';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';

import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';

import { firstFieldsGroup, secondFieldsGroup } from './constants';
import TableField from './components/CustomTable';
import styles from './styles.module.scss';

const validate = [required(message('Validations:required'))];

const EjesaSocialRate = ({ handleSubmit, invalid, submitFailed, onCancel, fieldValues }) => (
  <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit}>
    <UTForm replaceFieldNames fields={firstFieldsGroup} fieldValues={fieldValues} />
    <Field name="id2489" component={TableField} validate={validate} />
    <UTForm replaceFieldNames fields={secondFieldsGroup} fieldValues={fieldValues} />
    <div className={styles.buttonsContainer}>
      <UTButton uppercase secondary onPress={onCancel} className={styles.submitButton}>
        {message(`Commons:cancel`)}
      </UTButton>
      <UTButton disabled={invalid && submitFailed} type="submit" className={styles.submitButton} uppercase>
        {message(`Commons:send`)}
      </UTButton>
    </div>
  </form>
);

EjesaSocialRate.propTypes = {
  handleSubmit: func.isRequired,
  onCancel: func.isRequired,
  invalid: bool,
  submitFailed: bool,
  fieldValues: any // eslint-disable-line react/forbid-prop-types
};

export default reduxForm({ form: 'EJESA_SOCIAL_RATE' })(EjesaSocialRate);
